import App from "../App";
import ConsoleUtil from "./ConsoleUtil";

/**
 * Responsible for storing data locally.
 */
class LocalData {

    protected versionPrefix: string;
    protected localStorageIsAvailable:boolean;

    constructor() {
        this.versionPrefix = "v2";
        this.localStorageIsAvailable = this.testLocalStorage();
    }

    private testLocalStorage(){
        var test = 'test';
        try {
            localStorage.setItem(test, test);
            localStorage.removeItem(test);
            return true;
        } catch(e) {
            return false;
        }
    }
    
    /**
     * Save a value under a specific identifier.
     * @public
     * @param name
     * @param value
     */
    saveValue(name: string, value: any) {
        try {
            localStorage.setItem(this.versionPrefix + App.config.gameId + name, value);
        } catch (e) {
            ConsoleUtil.log("Cannot save to local storage.");
        }
    }


    /**
     * Retrieve a value under a specific identifier.
     * @public
     * @param name
     */
    getValue(name: string) {
        if(this.localStorageIsAvailable) {

            return localStorage.getItem(this.versionPrefix + App.config.gameId + name);
        } else {
            return;
        }
    }


    /**
     * Retrieve a value and cast it to a Number
     * @param name
     * @returns {number}
     */
    getNumber(name: string) {
        let val = this.getValue(name);
        let num;

        if (val !== null) {
            num = Number(val);
        }

        return num;
    }


    /**
     * Get a boolean value with specific identifier. If such identifier has not been previously used
     * it is saved with the specified init state.
     * @public
     * @param name
     * @param initState
     * @returns {Boolean}
     */
    getBooleanValue(name: string, initState = true): boolean {
        let b = this.getValue(name);

        if (b === null) {
            this.saveValue(name, initState);
        } else {
            return b === "true";
        }

        return !!b;
    }


}


export default new LocalData();
